import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    createStyles,
    Button,
    Collapse,
    Textarea,
    ScrollArea,
    FileInput,
    SimpleGrid,
    Stack,
    Image,
    Modal,
    Group,
    ActionIcon,
    Text,
    Tabs,
    Badge
} from '@mantine/core';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import {
    IconUpload,
    IconPhoto,
    IconVideo,
    IconArticle,
} from '@tabler/icons';


//needed:create top row




const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    stackPar: {
        backgroundColor: 'black'
    }
    
}));


export function MultiMediaGallery() {
    const [sectionCOpen, setSectionCOpened] = useState(false);
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const [briefDescript, setBriefDescript] = useState('');
    const onBriefDescriptChanged = (e) => setBriefDescript(e.target.value);
    

    let imageTemps = [];
    for(let i =0; i < 100; i++){
        let item = {
            altVal: `item number ${i}`
        }
        imageTemps.push(item);
    }
    
    //this works
    //add this change to the
    function handleImageClick(e){
        console.log(`image clicked ${e.currentTarget.id}`);
    }
    const imagesSection = imageTemps.map((item, index) => {
        return (
            <div
                id={`CustomID_${nanoid()}`}
                onClick={handleImageClick}
                key={nanoid()}
            >
                <Image
                    key={nanoid()}
                    width={90}
                    height={90}
                    src={null}
                    alt={item.altVal}
                    withPlaceholder
                    
                />
            </div>
        );
    })
    
    
    //needed:make a call to the db
    //needed:city and states in ref db
    //needed:custom image and card as the select model

    //needed:modal for viewing individual image
    //change: first group into tabs and make the children tab panels
    return (
        <>
            <Tabs defaultValue="photos">
                <Tabs.List>
                    <Tabs.Tab
                        value="photos"
                        icon={<IconPhoto color={"black"} size={20} stroke={2.0}/>}
                    >
                    Photos
                    </Tabs.Tab>
                    <Tabs.Tab
                        value="videos"
                        icon={<IconVideo color={"black"} size={20} stroke={2.0}/>}
                    >
                    Videos
                    </Tabs.Tab>
                    <Tabs.Tab
                        value="docs"
                        icon={<IconArticle color={"black"} size={20} stroke={2.0}/>}
                    >
                    Docs
                    </Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="photos">
                    <Stack align="stretch" justify="space-around">
                        <SimpleGrid cols={3}>
                            {imagesSection}
                        </SimpleGrid>
                    </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="videos">
                    <Stack align="stretch" justify="space-around">
                        <SimpleGrid cols={4}>
                            {imagesSection}
                        </SimpleGrid>
                    </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="docs">
                    <Stack align="stretch" justify="space-around">
                        <SimpleGrid cols={5}>
                            {imagesSection}
                        </SimpleGrid>
                    </Stack>
                </Tabs.Panel>
            </Tabs>
        </>
    );
    
}

